import React from 'react';

const FallbackErrorComponent = ({ error }: { error: Error }) => {
	console.log({ error });

	return <></>;
};

export default FallbackErrorComponent;
